import {
  Button,
  Checkbox,
  Form,
  Input,
  Modal,
  Select,
  Table,
  Tabs,
  Tag,
  Typography,
  message,
} from "antd";
import DatePicker from "../../../../../components/inputs/MomentDatePicker";
import axios from "axios";
import * as moment from "moment";
import React, { useEffect, useMemo, useState } from "react";
import { CSVLink } from "react-csv";
import { BiSearch } from "react-icons/bi";
import { useQuery, useQueryClient } from "react-query";
import { useLocation, useNavigate } from "react-router-dom";
import { serverUrl } from "../../../../../nestserver";
import { numberInputGuard } from "../../../../../components/inputs/numberInputGuard";
const { Option } = Select;

function tagRender(props) {
  const { label, closable, onClose } = props;

  const onPreventMouseDown = (event) => {
    event.preventDefault();
    event.stopPropagation();
  };
  return (
    <Tag
      onMouseDown={onPreventMouseDown}
      closable={closable}
      onClose={onClose}
      style={{ marginRight: 3 }}
      className="flex items-center"
    >
      {label}
    </Tag>
  );
}
const GenderSelect = ({ value, onChange }) => {
  return (
    <Select
      value={value}
      onChange={onChange}
      placeholder="Select Gender"
      getPopupContainer={(trigger) => trigger.parentNode}
    >
      <Option value="male">Male</Option>
      <Option value="female">Female</Option>
      <Option value="others">Other</Option>
    </Select>
  );
};
const BloodGroupSelect = ({ value, onChange }) => {
  return (
    <Select
      value={value}
      onChange={onChange}
      placeholder="Select Blood Group"
      getPopupContainer={(trigger) => trigger.parentNode}
      allowClear
    >
      <Option value="A+">A+</Option>
      <Option value="B+">B+</Option>
      <Option value="O+">O+</Option>
      <Option value="A-">A-</Option>
      <Option value="B-">B-</Option>
      <Option value="O-">O-</Option>
      <Option value="AB+">AB+</Option>
      <Option value="AB-">AB-</Option>
    </Select>
  );
};

// Class name, then roll number ascending (numeric); students without a roll
// number go last in their class, ordered by name.
const compareByClassAndRoll = (a, b) => {
  const classCmp = (a?.student?.class?.name ?? "").localeCompare(
    b?.student?.class?.name ?? "",
    undefined,
    { numeric: true, sensitivity: "base" },
  );
  if (classCmp) return classCmp;
  const rollA = parseInt(a?.student?.roll_number, 10);
  const rollB = parseInt(b?.student?.roll_number, 10);
  const hasA = !isNaN(rollA);
  const hasB = !isNaN(rollB);
  if (hasA && hasB && rollA !== rollB) return rollA - rollB;
  if (hasA !== hasB) return hasA ? -1 : 1;
  return `${a?.student?.first_name ?? ""} ${a?.student?.last_name ?? ""}`
    .toLowerCase()
    .localeCompare(
      `${b?.student?.first_name ?? ""} ${b?.student?.last_name ?? ""}`.toLowerCase(),
    );
};

function ManageStudentMain() {
  const { Search } = Input;
  const { Option } = Select;
  const [form] = Form.useForm();
  const navigate = useNavigate();
  const location = useLocation();
  const query = new URLSearchParams(location.search);
  const QueryClient = useQueryClient();
  const [search, setSearch] = useState(query.get("search") || "");
  const [selectButton, setSelectButton] = useState(query.get("class") || "All");
  const [classId, setClassId] = useState(null);
  const { Title } = Typography;

  const [addstudent, setAddStudent] = useState(false);
  const [subjectListing, setSubjectListing] = useState({
    subjects: [],
    co_curricular: [],
    languages: [],
  });
  const [transportationCheckbox, setTransportationCheckbox] = useState(false);
  const [accommodationCheckbox, setAccommodationCheckbox] = useState(false);
  const [selectedZoneId, setSelectedZoneId] = useState(null);
  const [routeId, setRouteId] = useState(null);

  const [tableState, setTableState] = useState({
    pagination: { current: Number(query.get("page")) || 1, pageSize: 10 },
  });

  const billingZones = useQuery(["transport-billing-zones"], async () => {
    const res = await axios.get(
      `${serverUrl}/admin/transport-billing-zone/list`,
      {
        headers: {
          Authorization: `Bearer ${window.localStorage.getItem("jwt-token")}`,
        },
      }
    );
    return res.data?.result || [];
  });

  const selectedZone = useMemo(
    () => billingZones.data?.find((z) => z._id === selectedZoneId) || null,
    [billingZones.data, selectedZoneId]
  );

  const routes = useQuery(["school-routes"], async () => {
    const headers = { Authorization: `Bearer ${window.localStorage.getItem("jwt-token")}` };
    const [v1Res, v2Res] = await Promise.all([
      axios.get(`${serverUrl}/routes`, { headers }),
      axios.get(`${serverUrl}/routes/v2`, { headers }),
    ]);
    const v1Data = v1Res.data?.result?.data || [];
    const v2Data = v2Res.data?.result?.data || [];
    return [
      ...v1Data.map((r) => ({ ...r, _version: "v1" })),
      ...v2Data.map((r) => ({ ...r, _version: "v2" })),
    ];
  });

  const routesDetail = useQuery(
    ["school-route-stops", routeId],
    async () => {
      const headers = { Authorization: `Bearer ${window.localStorage.getItem("jwt-token")}` };
      const routeInList = (routes.data || []).find((r) => r._id === routeId);
      const url = routeInList?._version === "v2"
        ? `${serverUrl}/routes/v2/${routeId}`
        : `${serverUrl}/routes/${routeId}`;
      const res = await axios.get(url, { headers });
      return res.data?.result?.data?.route_map || [];
    },
    { enabled: !!routeId }
  );

  // fetch subject
  async function fetchSubjects() {
    const res = await axios({
      method: "get",
      url: serverUrl + "/subjects/",
      headers: {
        Authorization: `Bearer ${window.localStorage.getItem("jwt-token")}`,
      },
    });

    return res.data;
  }
  const subjects = useQuery("subjects", fetchSubjects);

  // fetch students
  async function getStudents() {
    const res = await axios({
      method: "get",
      url: serverUrl + "/users/",
      params: {
        role: "student",
      },
      headers: {
        Authorization: `Bearer ${window.localStorage.getItem("jwt-token")}`,
      },
    });

    return res.data;
  }
  const students = useQuery("students", getStudents);

  // fetch Class
  const fetchClasses = async () => {
    const res = await axios({
      method: "get",
      url: serverUrl + "/classes",
      headers: {
        Authorization: `Bearer ${window.localStorage.getItem("jwt-token")}`,
      },
    });
    return res.data;
  };
  const classes = useQuery("classes", fetchClasses);

  useEffect(() => {
    if (classId && subjects?.isSuccess) {
      const mandatorySubjects = subjects?.data?.filter(
        (s) => s?.class?._id === classId && s?.is_mandatory,
      );
      const coCurricularSubjects = subjects?.data?.filter(
        (s) => s?.class?._id === classId && s?.is_co_curricular,
      );
      const languageSubjects = subjects?.data?.filter(
        (s) => s?.class?._id === classId && s?.is_language,
      );

      setSubjectListing({
        subjects: mandatorySubjects?.map((s) => s?._id),
        co_curricular: coCurricularSubjects?.map((s) => s?._id),
        languages: languageSubjects?.map((s) => s?._id),
      });
    }
  }, [classId, subjects?.data, subjects?.isSuccess]);

  const onFinish = (values) => {
    const payload = {
      role: "student",
      first_name: values?.first_name,
      last_name: values?.last_name,
      email: values?.email,
      username: values?.username,
      password: values?.confirm,
      class: values?.class,
      subjects: [...subjectListing.subjects],
      languages: values?.language ? values?.language : [],
      co_curricular: values?.curricular ? values?.curricular : [],
      nationality: values?.nationality,
      birth_place: values?.birth_place,
      religion: values?.religion,
      category: values?.category,
      ethnicity: values?.ethnicity,
      blood_group: values?.blood_group,
      aadhar: values?.aadhar,
      admission_number: values?.admissionNumber,
      gender: values?.gender,
      phone: values?.phone,
      admission_date: moment(values?.admissionDate).format("YYYY-MM-DD"),
      dob: moment(values?.dob).format("YYYY-MM-DD"),
      is_transportation_required: transportationCheckbox,
      is_accommodation_required: accommodationCheckbox,
      transport_zone_id: values.transport_zone_id || null,
      transport_destination_id: values?.transport_destination_id || null,
      route_id: values?.route_id || null,
      route_entry_point_id: values?.route_entry_point_id || null,
      primary_contact: {
        first_name: values?.primary_contact_first_name,
        last_name: values?.primary_contact_last_name,
        relation: values?.primary_contact_relation,
        contact: values?.primary_contact_phone,
        email: values?.primary_contact_email,
      },
      secondary_contact: {
        first_name: values?.secondary_contact_first_name,
        last_name: values?.secondary_contact_last_name,
        relation: values?.secondary_contact_relation,
        contact: values?.secondary_contact_phone,
        email: values?.secondary_contact_email,
      },
    };
    axios({
      method: "post",
      url: serverUrl + "/users/",
      data: payload,
      headers: {
        Authorization: `Bearer ${window.localStorage.getItem("jwt-token")}`,
      },
    })
      .then((res) => {
        setAddStudent(false);
        form.resetFields();
        setSubjectListing({
          subjects: [],
          co_curricular: [],
          languages: [],
        });
        message.success("Student added");
        QueryClient.invalidateQueries("students");
      })
      .catch((error) => {
        if (error?.response?.data) {
          message.error(error?.response?.data.message);
        } else {
          message.error(error?.message);
        }
      });
  };

  const selectChange = (values) => {
    setSelectButton(values);
    setTableState({ pagination: { ...tableState.pagination, current: 1 } });
  };

  // Table config
  const columns = [
    {
      title: "Student Name",
      key: "x",
      render: (text) => (
        <div
          key={text?._id}
          style={{ color: "#616161" }}
          className=" text-base font-semibold capitalize"
        >
          {text?.student?.first_name} {text?.student?.last_name}
        </div>
      ),
    },
    {
      title: "Class",
      key: "",
      render: (text) => (
        <div
          key={text?._id}
          style={{ color: "#616161" }}
          className=" text-base font-semibold"
        >
          {text?.student?.class?.name}
        </div>
      ),
    },
    {
      title: "Roll Number",
      key: "rollNumber",
      dataIndex: ["student", "roll_number"],
      sorter: (a, b) =>
        (parseInt(a.student?.roll_number, 10) || Infinity) -
        (parseInt(b.student?.roll_number, 10) || Infinity) || 0,
      render: (text, record) => (
        <div
          key={record._id}
          style={{ color: "#616161" }}
          className="text-base font-semibold capitalize"
        >
          {text}
        </div>
      ),
    },

    {
      title: "Action",
      key: "action",
      render: (text) => (
        <div
          key={text?._id}
          className=" text-base font-semibold text-blue-500 cursor-pointer"
          onClick={() =>
            navigate(`/dashboard/admin/menu/student/profile/${text?._id}`)
          }
        >
          View Details
        </div>
      ),
    },
  ];

  const filteredStudents = useMemo(() => {
    let filtered = students.data;

    if (selectButton !== "All") {
      filtered = filtered?.filter(
        (f) => f.student?.class?._id === selectButton,
      );
    }

    if (search) {
      filtered = filtered.filter(
        (f) =>
          f.student?.first_name.toLowerCase().includes(search) ||
          f.student?.last_name.toLowerCase().includes(search) ||
          (f.student.first_name + " " + f.student.last_name)
            .toLowerCase()
            .includes(search.toLowerCase()),
      );
    }

    return filtered;
  }, [students.data, search, selectButton]);

  const studentExportData = useMemo(() => {
    const ExportData = [];
    students?.data &&
      students.data?.forEach((student) => {
        ExportData?.push({
          Name:
            student?.student?.first_name + " " + student?.student?.last_name,
          Batch: student?.student?.batch,
          Class: student?.student?.class?.name,
          Subjects: student?.student?.subjects?.map((s) => s.name).join(", "),
          Attendance: student?.attendance
            ? (student?.attendance?.filter((a) => a.attended === true)?.length /
                student?.attendance?.length) *
              100
            : "",
          Email: student?.email,
          Username: student?.username,
          " Academic Year": `${moment(
            student?.student?.class?.academic_start_date,
          ).format("yyyy")}-${moment(
            student?.student?.class?.academic_end_date,
          ).format("yyyy")}`,
        });
      });
    return ExportData;
  }, [students.data]);

  const validateAlphabetsOnly = (_, value) => {
    const regex = /^[a-zA-Z\s]*$/;
    if (!regex.test(value)) {
      return Promise.reject("Please enter alphabets only");
    }
    return Promise.resolve();
  };
  useEffect(() => {
    form.resetFields(["language", "curricular"]);
  }, [classId, form]);

  // Keep search / class tab / page in the URL so they are restored on return
  // from a student's profile.
  useEffect(() => {
    const params = new URLSearchParams();
    if (search) params.set("search", search);
    if (selectButton !== "All") params.set("class", selectButton);
    if (tableState.pagination.current !== 1) {
      params.set("page", tableState.pagination.current);
    }
    navigate(
      { pathname: location.pathname, search: params.toString() },
      { replace: true }
    );
  }, [search, selectButton, tableState, navigate, location.pathname]);

  return (
    <>
      <div className="p-8">
        <div
          style={{ borderRadius: "10px", color: "#616161" }}
          className=" bg-white drop-shadow-md p-8 w-full "
        >
          <div className="flex items-center justify-between">
            <div className="text-2xl text-orange-500 font-semibold">
              Students
            </div>
            <div className=" flex space-x-5">
              {/* <Button onClick={() => setAddStudent(true)} type="primary">
                Add New Student
              </Button> */}
              <CSVLink filename={`students.csv`} data={studentExportData}>
                <Button>Export Students</Button>
              </CSVLink>
              <div compact className="flex flex-row items-center">
                <Search
                  value={search}
                  placeholder="input search text"
                  enterButton="Search"
                  loading={false}
                  style={{ backgroundColor: "#E3E3E3" }}
                  prefix={<BiSearch className="text-gray-600 " />}
                  onSearch={(e) => setSearch(e)}
                  onChange={(e) => setSearch(e.target.value)}
                />
              </div>
            </div>
          </div>
          <div className="pt-4">
            <Tabs activeKey={selectButton} onChange={selectChange}>
              <Tabs.TabPane tab="All" key="All" />
              {classes.isSuccess &&
                classes.data.map((c) => (
                  <Tabs.TabPane tab={c.name} key={c._id} />
                ))}
            </Tabs>
          </div>
          <div className="py-5">
            <Table
              columns={columns}
              dataSource={filteredStudents?.sort(compareByClassAndRoll)}
              pagination={tableState.pagination}
              onChange={(pagination) => setTableState({ pagination })}
              rowKey={(record) => record._id}
            />
          </div>
        </div>
      </div>
      {/* ----------------------------------modal------------------------------------ */}

      <Modal
        width={800}
        visible={addstudent}
        onOk={() => setAddStudent(false)}
        onCancel={() => {
          setAddStudent(false);
          form.resetFields();
          // setSubjectListing({
          //   subjects: [],
          //   co_curricular: [],
          //   languages: [],
          // });
          setClassId("");
        }}
        footer={null}
      >
        <div>
          <div className="py-2">
            <div className="text-2xl font-bold text-black pb-4 capitalize">
              Add Student
            </div>
          </div>
          {/* ---------------------------form---------------- */}

          <Form
            layout="vertical"
            name="basic"
            form={form}
            initialValues={{ remember: true }}
            onFinish={onFinish}
            autoComplete="off"
          >
            <div>
              <div className="grid grid-cols-2 gap-x-4">
                <Form.Item
                  label="First Name"
                  name="first_name"
                  rules={[
                    {
                      required: true,
                      message: "Please input your first name!",
                    },
                    {
                      validator: validateAlphabetsOnly,
                    },
                  ]}
                >
                  <Input type="text" />
                </Form.Item>
                <Form.Item
                  label="Last Name"
                  name="last_name"
                  rules={[
                    {
                      required: true,
                      message: "Please input your last name!",
                    },
                    {
                      validator: validateAlphabetsOnly,
                    },
                  ]}
                >
                  <Input type="text" />
                </Form.Item>
              </div>

              <div className="grid grid-cols-2 gap-x-4">
                <Form.Item
                  name="email"
                  label="Email Address"
                  rules={[
                    {
                      required: true,
                      message: "Please input your Email!",
                    },
                  ]}
                >
                  <Input type="email" />
                </Form.Item>
                <Form.Item
                  label="Password"
                  name="password"
                  rules={[
                    {
                      required: true,
                      message: "Please input your Password!",
                    },
                    {
                      min: 6,
                      message: "Password must be at least 6 characters long!",
                    },
                  ]}
                >
                  <Input.Password />
                </Form.Item>
              </div>
              <div className="grid grid-cols-2 gap-x-4">
                <Form.Item
                  name="confirm"
                  label="Confirm Password"
                  dependencies={["password"]}
                  hasFeedback
                  rules={[
                    {
                      required: true,
                      message: "Please confirm your password!",
                    },
                    ({ getFieldValue }) => ({
                      validator(_, value) {
                        if (!value || getFieldValue("password") === value) {
                          return Promise.resolve();
                        }
                        return Promise.reject(
                          new Error(
                            "The two passwords that you entered do not match!",
                          ),
                        );
                      },
                    }),
                  ]}
                >
                  <Input.Password />
                </Form.Item>
                <Form.Item
                  name="admission_date"
                  label="Admission Date"
                  rules={[
                    {
                      required: true,
                      message: "Admission date  is required",
                    },
                  ]}
                  className="w-30"
                >
                  <DatePicker
                    format="DD-MM-YYYY"
                    placeholder="Please select"
                    disabledDate={(current) =>
                      current && current > moment().endOf("day")
                    }
                    getPopupContainer={(trigger) => trigger.parentNode}
                    className="w-full"
                  />
                </Form.Item>
              </div>
              <div className="grid grid-cols-2 gap-x-4">
                <Form.Item
                  name="admissionNumber"
                  label="Admission Number"
                  className="w-30"
                  getValueFromEvent={(e) => e.target.value}
                  rules={[
                    {
                      required: true,
                      message: "Admission number  is required",
                    },
                  ]}
                >
                  <Input />
                </Form.Item>
                <Form.Item
                  name="aadhar"
                  label="Aadhar"
                  className="w-30"
                  rules={[
                    {
                      pattern: /^[0-9]{12}$/, // Updated regex pattern to match 12 digits
                      message: "Please enter a valid 12-digit Number!",
                    },
                  ]}
                  getValueFromEvent={(e) => e.target.value.slice(0, 12)}
                >
                  <Input maxLength={12} type="number" min={0} {...numberInputGuard} />
                </Form.Item>
              </div>
              <div className="grid grid-cols-2 gap-x-4">
                <Form.Item
                  name="blood_group"
                  label="Blood Group"
                  className="w-30"
                >
                  <BloodGroupSelect />
                </Form.Item>
                <Form.Item
                  label="Class"
                  name="class"
                  className="w-full"
                  rules={[
                    {
                      required: true,
                      message: "Please select a class",
                    },
                  ]}
                >
                  <Select
                    showSearch
                    showArrow
                    placeholder="Select Class"
                    optionFilterProp="children"
                    filterOption={(input, option) =>
                      option.children
                        .toLowerCase()
                        .indexOf(input.toLowerCase()) >= 0
                    }
                    filterSort={(optionA, optionB) =>
                      optionA.children
                        .toLowerCase()
                        .localeCompare(optionB.children.toLowerCase())
                    }
                    className="w-full bg-gray-300"
                    style={{
                      border: "6px",
                      backgroundColor: "#EBEBEB",
                    }}
                    onChange={(e) => {
                      setClassId(e);
                    }}
                    getPopupContainer={(trigger) => trigger.parentNode}
                  >
                    {classes.isSuccess &&
                      classes?.data?.map((data) => {
                        return (
                          <Option key={data._id} value={data._id}>
                            {data.name}
                          </Option>
                        );
                      })}
                  </Select>
                </Form.Item>
              </div>
              {classId && (
                <>
                  <div className="pb-2"> Mandatory</div>
                  <div className="flex flex-wrap gap-3 pb-4">
                    {subjects.isSuccess &&
                      subjects?.data
                        ?.filter(
                          (s) =>
                            s.class?._id === classId && s.is_mandatory === true,
                        )
                        ?.map((data) => (
                          <div
                            key={data._id}
                            className="bg-gray-200 px-4 py-2 rounded-md text-gray-700 iskool-friends-card capitalize"
                          >
                            {data.name}
                          </div>
                        ))}
                  </div>
                  <Form.Item name="language" label="Languages">
                    <Select
                      mode="multiple"
                      showArrow
                      tagRender={tagRender}
                      placeholder="Select language"
                      style={{
                        border: "6px",
                        backgroundColor: "#EBEBEB",
                      }}
                      className="w-full"
                      optionFilterProp="children"
                      filterOption={(input, option) =>
                        option.children
                          .toLowerCase()
                          .indexOf(input.toLowerCase()) >= 0
                      }
                      getPopupContainer={(trigger) => trigger.parentNode}
                    >
                      {subjects.isSuccess &&
                        subjects?.data
                          ?.filter(
                            (s) =>
                              s?.class?._id === classId &&
                              s?.is_language === true,
                          )
                          ?.map((data) => {
                            return (
                              <Option key={data._id} value={data._id}>
                                {data?.name}
                              </Option>
                            );
                          })}
                    </Select>
                  </Form.Item>
                  <Form.Item name="curricular" label="Co-Curricular">
                    <Select
                      mode="multiple"
                      showArrow
                      tagRender={tagRender}
                      placeholder="Select co-Curricular"
                      style={{
                        border: "6px",
                        backgroundColor: "#EBEBEB",
                      }}
                      className="w-full"
                      optionFilterProp="children"
                      filterOption={(input, option) =>
                        option.children
                          .toLowerCase()
                          .indexOf(input.toLowerCase()) >= 0
                      }
                      getPopupContainer={(trigger) => trigger.parentNode}
                    >
                      {subjects.isSuccess &&
                        subjects?.data
                          ?.filter(
                            (s) =>
                              s?.class?._id === classId &&
                              s?.is_co_curricular === true,
                          )
                          ?.map((data) => {
                            return (
                              <Option key={data._id} value={data._id}>
                                {data?.name}
                              </Option>
                            );
                          })}
                    </Select>
                  </Form.Item>
                </>
              )}
              <div className="grid grid-cols-2 gap-x-4">
                <Form.Item
                  name="dob"
                  label="Date Of Birth"
                  rules={[
                    {
                      required: true,
                      message: "Date of Birth  is required",
                    },
                  ]}
                  className="w-full"
                >
                  <DatePicker
                    format="DD-MM-YYYY"
                    placeholder="Please select your date of birth"
                    disabledDate={(current) =>
                      current && current > moment().endOf("day")
                    }
                    getPopupContainer={(trigger) => trigger.parentNode}
                    className="w-full"
                  />
                </Form.Item>
                <Form.Item
                  name="gender"
                  label="Gender"
                  rules={[
                    {
                      required: true,
                      message: "Gender is required",
                    },
                  ]}
                  className="w-30"
                >
                  <GenderSelect />
                </Form.Item>
              </div>
              <div className="grid grid-cols-2 gap-x-4">
                <Form.Item
                  name="phone"
                  label="Phone"
                  className="w-30"
                  rules={[
                    {
                      pattern: /^[0-9]{10}$/, // Adjust the regex pattern as needed
                      message: "Please enter a valid 10-digit phone number!",
                    },
                  ]}
                  getValueFromEvent={(e) => e.target.value.slice(0, 10)}
                >
                  <Input type="number" maxLength={10} min={0} {...numberInputGuard} />
                </Form.Item>
                <Form.Item
                  name="birth_place"
                  label="Birth Place"
                  className="w-30"
                >
                  <Input />
                </Form.Item>
              </div>
              <div className="grid grid-cols-2 gap-x-4">
                <Form.Item
                  name="category"
                  label="Category"
                  className="w-30"
                  rules={[
                    {
                      validator: validateAlphabetsOnly,
                    },
                  ]}
                >
                  <Input />
                </Form.Item>
                <Form.Item
                  name="religion"
                  label="Religion"
                  className="w-30"
                  rules={[
                    {
                      validator: validateAlphabetsOnly,
                    },
                  ]}
                >
                  <Input />
                </Form.Item>
              </div>
              <div className="grid grid-cols-2 gap-x-4">
                <Form.Item
                  name="nationality"
                  label="Nationality"
                  className="w-30"
                  rules={[
                    {
                      required: true,
                      message: "Nationality is required",
                    },
                    {
                      validator: validateAlphabetsOnly,
                    },
                  ]}
                >
                  <Input />
                </Form.Item>
                <Form.Item name="ethnicity" label="Ethnicity" className="w-30">
                  <Input />
                </Form.Item>
              </div>
              <Title level={2}>Primary Contact</Title>
              <div className="grid grid-cols-2 gap-x-4">
                <Form.Item
                  name="primary_contact_first_name"
                  label="First Name"
                  className="w-30"
                  rules={[
                    {
                      required: true,
                      message: "First name is required",
                    },
                  ]}
                >
                  <Input />
                </Form.Item>
                <Form.Item
                  name="primary_contact_last_name"
                  label="Last Name"
                  className="w-30"
                  rules={[
                    {
                      required: true,
                      message: "Last name is required",
                    },
                  ]}
                >
                  <Input />
                </Form.Item>
              </div>
              <div className="grid grid-cols-2 gap-x-4">
                <Form.Item
                  name="primary_contact_phone"
                  label="Phone"
                  className="w-30"
                  rules={[
                    {
                      required: true,
                      message: "Phone is required",
                    },
                    {
                      pattern: /^[0-9]{10}$/, // Adjust the regex pattern as needed
                      message: "Please enter a valid 10-digit phone number!",
                    },
                  ]}
                  getValueFromEvent={(e) => e.target.value.slice(0, 10)}
                >
                  <Input type="number" maxLength={10} min={0} {...numberInputGuard} />
                </Form.Item>
                <Form.Item
                  name="primary_contact_email"
                  label="Email"
                  className="w-30"
                  rules={[
                    {
                      type: "email",
                      message: "Please enter a valid email",
                    },
                  ]}
                >
                  <Input />
                </Form.Item>
              </div>
              <div className="grid grid-cols-2 gap-x-4">
                <Form.Item
                  name="primary_contact_relation"
                  label="Relation"
                  className="w-30"
                  rules={[
                    {
                      required: true,
                      message: "Relation is required",
                    },
                    {
                      validator: validateAlphabetsOnly,
                    },
                  ]}
                >
                  <Input />
                </Form.Item>
              </div>
              <Title level={2}>Secondary Contact</Title>
              <div className="grid grid-cols-2 gap-x-4">
                <Form.Item
                  name="secondary_contact_first_name"
                  label="First Name"
                  className="w-30"
                >
                  <Input />
                </Form.Item>
                <Form.Item
                  name="secondary_contact_last_name"
                  label="Last Name"
                  className="w-30"
                >
                  <Input />
                </Form.Item>
              </div>
              <div className="grid grid-cols-2 gap-x-4">
                <Form.Item
                  name="secondary_contact_phone"
                  label="Phone"
                  className="w-30"
                  rules={[
                    {
                      pattern: /^[0-9]{10}$/, // Adjust the regex pattern as needed
                      message: "Please enter a valid 10-digit phone number!",
                    },
                  ]}
                  getValueFromEvent={(e) => e.target.value.slice(0, 10)}
                >
                  <Input type="number" maxLength={10} min={0} {...numberInputGuard} />
                </Form.Item>
                <Form.Item
                  name="secondary_contact_email"
                  label="Email"
                  className="w-30"
                  rules={[
                    {
                      type: "email",
                      message: "Please enter a valid email",
                    },
                  ]}
                >
                  <Input />
                </Form.Item>
              </div>
              <div className="grid grid-cols-2 gap-x-4">
                <Form.Item
                  name="secondary_contact_relation"
                  label="Relation"
                  className="w-30"
                  rules={[
                    {
                      validator: validateAlphabetsOnly,
                    },
                  ]}
                >
                  <Input />
                </Form.Item>
              </div>
              <Title level={2}>Transportation</Title>
              <Form.Item
                name="is_transportation_required"
                valuePropName="checked"
              >
                <Checkbox
                  onChange={(e) => {
                    setTransportationCheckbox(e.target.checked);
                    form.resetFields(["transport_zone_id", "transport_destination_id", "route_id", "route_entry_point_id"]);
                    setSelectedZoneId(null);
                    setRouteId(null);
                  }}
                  checked={transportationCheckbox}
                >
                  Transportation require?
                </Checkbox>
              </Form.Item>
              <div>
                {transportationCheckbox && (
                  <div className="admission-form">
                    <Form.Item
                      label="Transport Zone"
                      name="transport_zone_id"
                      className="w-full"
                    >
                      <Select
                        showSearch
                        showArrow
                        placeholder="Select Zone"
                        className="bg-gray-300"
                        style={{ border: "6px", backgroundColor: "#EBEBEB" }}
                        getPopupContainer={(trigger) => trigger.parentNode}
                        onChange={(value) => {
                          setSelectedZoneId(value);
                          form.resetFields(["transport_destination_id"]);
                        }}
                      >
                        {billingZones?.isSuccess &&
                          billingZones?.data?.map((zone) => (
                            <Option key={zone._id} value={zone._id}>
                              {zone.name}
                            </Option>
                          ))}
                      </Select>
                    </Form.Item>
                    <Form.Item
                      label="Destination"
                      name="transport_destination_id"
                      className="w-full"
                    >
                      <Select
                        showSearch
                        showArrow
                        placeholder="Select Destination"
                        className="w-full bg-gray-300"
                        style={{ border: "6px", backgroundColor: "#EBEBEB" }}
                        getPopupContainer={(trigger) => trigger.parentNode}
                        disabled={!selectedZoneId}
                      >
                        {selectedZone?.destinations?.map((dest) => (
                          <Option key={dest._id} value={dest._id}>
                            {dest.name} — ₹{Number(dest.amount).toLocaleString("en-IN")}
                          </Option>
                        ))}
                      </Select>
                    </Form.Item>
                  </div>
                )}
                {transportationCheckbox && (
                  <div className="mt-4" style={{ borderTop: "1px solid #e8e8e8", paddingTop: 16 }}>
                    <div className="font-medium text-gray-600 mb-3" style={{ fontSize: 13 }}>Bus Tracking (Live Tracking App)</div>
                    <div className="grid grid-cols-2 gap-x-4">
                      <Form.Item label="Route" name="route_id" className="w-full">
                        <Select
                          showSearch
                          showArrow
                          allowClear
                          placeholder="Select Route"
                          className="w-full"
                          loading={routes.isLoading}
                          onChange={(value) => {
                            setRouteId(value || null);
                            form.resetFields(["route_entry_point_id"]);
                          }}
                        >
                          {(routes.data || []).map((route) => (
                            <Option key={route._id} value={route._id}>
                              {route.name}
                            </Option>
                          ))}
                        </Select>
                      </Form.Item>
                      <Form.Item label="Entry Point" name="route_entry_point_id" className="w-full">
                        <Select
                          showSearch
                          showArrow
                          allowClear
                          placeholder={routeId ? "Select entry point" : "Select a route first"}
                          className="w-full"
                          disabled={!routeId}
                        >
                          {(routesDetail.data || []).map((stop) => (
                            <Option key={stop._id} value={stop._id}>
                              {stop.name}
                            </Option>
                          ))}
                        </Select>
                      </Form.Item>
                    </div>
                  </div>
                )}
              </div>
              <Title level={2}>Accommodation</Title>
              <Form.Item
                name="is_accommodation_required"
                valuePropName="checked"
              >
                <Checkbox
                  onChange={(e) => {
                    setAccommodationCheckbox(e.target.checked);
                  }}
                  checked={accommodationCheckbox}
                >
                  Accommodation require?
                </Checkbox>
              </Form.Item>
            </div>
            {/* ----------------------------------------------- */}
            <div className="flex justify-end items-center pt-6">
              <div className="inline-flex items-center space-x-2">
                <Button
                  onClick={() => {
                    setAddStudent(false);
                    form.resetFields();
                  }}
                  size="large"
                  type="dark"
                >
                  Cancel
                </Button>

                <Button
                  size="large"
                  type="primary"
                  htmlType="submit"
                  className="text-white"
                >
                  Save
                </Button>
              </div>
            </div>
          </Form>
        </div>
      </Modal>
    </>
  );
}

export default ManageStudentMain;




